import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const locationInventoryValueWidget: DashboardWidgetConfiguration = {
  widgetId: "location.inventory-value",
  name: "Inventory value",
  description: "Inventory value for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.stock",
      ...period(1),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "inventory_value",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Inventory value",
    subtext: "",
    icon: "money",
    color: "success",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
